// extracted by mini-css-extract-plugin
module.exports = {"root":"edit-button-module__root___2UQNr","title":"edit-button-module__title___1VLVP"};